import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../app/store';
import MoodleConfigForm from './MoodleConfigForm';
import { useMoodleConfig } from './useMoodleConfig';



export const MoodleLmsConfiguration = () => {
  const currentUser = useSelector((state: RootState) => state.currentUser);
  const {
    config,
    isLoading,
    handleUpdateConfiguration,
    setConfig,
  } = useMoodleConfig(currentUser.organization_id);
  return (
    <div className="p-4 bg-white border rounded shadow-md">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-bold mb-4">Moodle Configuration</h2>
      </div>
      {isLoading ? (
        <p>Loading...</p>

      ) : (
        <MoodleConfigForm
          config={{
            lmsUrl: config.lmsUrl,
            refreshToken: config.refreshToken,
            proviewWsFunction: config.proviewWsFunction,
            proviewName:config.proviewName
          }}
          setConfig={setConfig}
          handleUpdateConfiguration={handleUpdateConfiguration}
        />
      )}
    </div>
  );
};
